module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum + Red Closed.d11db4fc.png";